<template>
  <div class="content">
    <el-row style="width: 94%;
    padding-top: 3%;
    margin-left: 3%;
    background-color: white;
    text-align: left;
    font-family: Calibri;
    padding-bottom:200px;">
      <el-col>
        <el-row style="padding-top: 15px;">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Figure 1 shows the technical flowchart for mapping flood risk of the world. The study revised the existing vulnerability functions by adjustment coefficient that is calculated based on recorded death tolls. Then future death tolls were estimated using predicted inundation data and population data, and adjusted vulnerability functions. After that the future death tolls of grid level were transformed to other geographical units. Finally, the influence of risk change was divided into climate change effect, population change effect and joint change effect to analyze the contribution level of every part.        </el-row>
        <el-row style="text-align: center;">
          <img style="width: 80%;" src="http://bunjs.aiside.top/8-1.png"/>
          <br/>
          <span>Fig.1 Technical flowchart</span>
        </el-row>



        <el-row class="r_marginTop r_title">Estimation of losses for baseline</el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          The mortality vulnerability function is Equation 1. Using the function, historical death tolls were estimated by Equations 2 and 3.
        </el-row>
        <el-row style="text-align: center;">
          <img style="" src="http://bunjs.aiside.top/8-2.png"/>
        </el-row>
        <el-row class="r_content">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          where Φ is the cumulative normal distribution. d is the water depth.
        </el-row>
        <el-row style="text-align: center;">
          <img style="" src="http://bunjs.aiside.top/8-3.png"/>
        </el-row>
        <el-row class="r_content">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          where i is the order of 11 AOGCMs; j is the sequence of 20 years; his is baseline period (1986-2005);
          <span style="font-style: italic;font-weight: bold;">L<span style="vertical-align: sub">his_i_j</span></span>,
          <span style="font-style: italic;font-weight: bold;">d<span style="vertical-align: sub">his_i_j</span></span> and
          <span style="font-style: italic;font-weight: bold;">f<span style="vertical-align: sub">his_i_j</span></span> are the estimated death tolls,
          water depth and inundation fraction for the <span style="font-style: italic">i</span>th AOGCM in the <span style="font-style: italic">j</span>th year for baseline period, respectively;
          <span style="font-style: italic;font-weight: bold;">S<span style="vertical-align: sub">his_j</span></span>,
          is the population size in the <span style="font-style: italic;">j</span>th year of baseline period.
          <span style="font-style: italic;font-weight: bold;">L<span style="vertical-align: sub">his</span></span>,
          is the annual average death tolls, that is multi-model ensemble, for baseline period. <span style="font-weight:bold;font-style: italic;">V(d)</span> is the vulnerability function.
        </el-row>



        <el-row class="r_marginTop r_title">Calculation of adjustment coefficients</el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          The study revised mortality vulnerability function (Equation 1) for countries to reduce the diversity of vulnerability functions in different areas.
          <br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Using the Equation 4, the adjustment coefficients were calculated at country level. Specially, the adjustment coefficient was the minimum of all calculated Kc values for countries with total recorded death tolls equal to zero during baseline period; the adjustment coefficient was the average of all calculated Kc values for countries with total recorded death tolls greater than zero but total estimated deaths equal to zero.
        </el-row>
        <el-row style="text-align: center;">
          <img style="" src="http://bunjs.aiside.top/8-4.png"/>
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          where <span style="font-style: italic;"> K<span style="vertical-align: sub;">c</span></span> is the adjustment coefficient of country
          <span style="font-style: italic">c</span> and <span style="font-style: italic">j</span> represents the sequential number of the 20 years in
          the baseline. <span style="font-style: italic;font-weight: bold;">SL<span style="vertical-align: sub;">his_c_j</span></span> is the recorded death tolls of country c.
        </el-row>

        <el-row class="r_content">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          The adjusted vulnerability function is shown in Equation 5.
        </el-row>
        <el-row style="text-align: center;">
          <img style="" src="http://bunjs.aiside.top/8-5.png"/>
        </el-row>
        <el-row class="r_content">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          where AdjMc(dep) is the adjusted vulnerability function of country c.
        </el-row>




        <el-row class="r_title r_marginTop">
          Calculation of future losses and change
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          Future death tolls of a grid in country c were estimated according to Equation 6, based on future predicted inundation and population data, and adjusted vulnerability function. Next the study averaged the results of 20 years for all AOGCMs (Equation 7) to compute uncertainties; then average the results of 11 AOGCMs as the death tolls of 2030s or 2050s to reduce model uncertainties (Equation 8). Finally, the changes of death tolls from baseline to future period were calculated by Equation 9.
        </el-row>
        <el-row style="text-align: center;">
          <img style="" src="http://bunjs.aiside.top/8-6.png"/>
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          where
          <span style="font-weight: bold;font-style: italic;">L<span style="vertical-align: sub;">fut_i_j</span></span> &nbsp;&nbsp;
          <span style="font-weight: bold;font-style: italic;">d<span style="vertical-align: sub;">fut_i_j</span></span>&nbsp;&nbsp;
          and&nbsp;&nbsp;
          <span style="font-weight: bold;font-style: italic;">f<span style="vertical-align: sub;">fut_i_j</span></span>&nbsp;&nbsp;
          are the estimated death tolls, water depth and inundation fraction for the <span style="font-style: italic;">i</span>th AOGCM in the
          <span style="font-style: italic;">j</span>th year for future period, respectively;
          <span style="font-weight: bold;font-style: italic;">S<span style="vertical-align: sub;">fut_j</span></span> &nbsp;&nbsp;
           is the population data in the <span style="font-style: italic;">j</span>th year of future period.
        </el-row>
        <el-row style="text-align: center;">
          <img style="" src="http://bunjs.aiside.top/8-7.png"/>
        </el-row>

        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          where
          <span style="font-weight: bold;font-style: italic;">L<span style="vertical-align: sub;">fut_j</span></span>is the average death tolls of 20 years (2016-2035 or 2046-2065) for the ith AOGCM.
        </el-row>
        <el-row style="text-align: center;">
          <img style="" src="http://bunjs.aiside.top/8-8.png"/>
        </el-row>

        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;where  <span style="font-weight: bold;font-style: italic;">L<span style="vertical-align: sub;">fut</span></span> is the death tolls of 2030s or 2050s for multi-model ensemble, which averaged the results from the 11 AOGCMs.
        </el-row>
        <el-row style="text-align: center;">
          <img style="" src="http://bunjs.aiside.top/8-9.png"/>
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;where ∆L is the change of death tolls for 2030s or 2050s relative to baseline.
        </el-row>




        <el-row class="r_title">
          Model uncertainty
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The result uncertainty of multi-models is measured by standard deviation (Equation 10) and coefficient of variation (Equation 11).
        </el-row>
        <el-row style="text-align: center;">
          <img style="" src="http://bunjs.aiside.top/8-10.png"/>
        </el-row>
        <el-row>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;where
          <span style="font-weight: bold;font-style: italic;">L<span style="vertical-align: sub;">i</span></span>is the average death tolls of 20 years for the
          <span style="font-style: italic;">i</span>th
          AOGCM ( <span style="font-weight: bold;font-style: italic;">L<span style="vertical-align: sub;">his_i</span></span> or  <span style="font-weight: bold;font-style: italic;">L<span style="vertical-align: sub;">fut_i</span></span>).  <span style="font-style: italic;">L</span> is the average death tolls of 20 years for multi-model ensemble
          ( <span style="font-weight: bold;font-style: italic;">L<span style="vertical-align: sub;">his</span></span> or  <span style="font-weight: bold;font-style: italic;">L<span style="vertical-align: sub;">fut</span></span>).
        </el-row>
        <el-row style="text-align: center;">
          <img style="" src="http://bunjs.aiside.top/8-11.png"/>
        </el-row>










      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "GlobalMortalityRiskToRiverFloods"
  }
</script>

<style scoped>

  .r_content{

  }
  .r_marginTop{
    margin-top: 15px;
  }

  .r_title{
    font-weight: bold;
    font-size: 2.5rem;
    margin-top: 30px;
  }



  .content{
    overflow-y: scroll;
    line-height: 40px;
    font-size: 2.2rem;
    color: black;
  }
  .content::-webkit-scrollbar {
    display: none;/*隐藏滚动条*/
  }
</style>



// WEBPACK FOOTER //
// src/view/BSD/About/GlobalMortalityRiskToRiverFloods.vue